import React from 'react';
import _ from 'lodash';
import Helmet from 'react-helmet';
import ClipLoader from 'react-spinners/ClipLoader';

import { PartnerNaviList } from '../components/list/PartnerNaviList';
import { PrimaryCompanyNaviList } from '../components/list/PrimaryCompanyNaviList';
import { MasterPageHeader } from '../components/PageHeader';
import { CcusUserDropdown } from '../components/CcusUserDropdown';
import { Confirmation, Information } from '../components/modals/common';
import { HEAD_OFFICE_OPTION } from '../components/PartnerCompanyBranchDropdown';
import { CloseEditView } from '../components/CloseEditView';

import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import PrimeCCUSPreviewService from '../services/PrimeCCUSPreview';
import { CompanyService } from '../services/Companies';
import CompanyBranchService from '../services/CompanyBranches';
import UserProfileService from '../services/UserProfiles';

import { HEADER_CONSTANTS } from '../utilities/constants';
import {
  isPartnerRoleId,
  isPrimaryCompanyRoleId,
} from '../utilities/roleUtility';
import { messageUtility } from '../utilities/messageUtility';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import dialogLoader from '../utilities/dialogLoader';
import {
  getPartnerCompanyName,
  propsToCompanyId,
} from '../utilities/partnerCompanyConfirmUtil';
import { requestCache } from '../utilities/requestCache';
import { CCUS_PAGE } from './PrimeCcusPreview';

class CcusUserEdit extends React.Component {
  constructor(props) {
    super(props);

    this.isCreating = true;
    this.selectedCompanyId = SessionStorageService.getItem('companyCcusId');
    this.ccusId = propsToCompanyId(this.props);
    this.isRolePartner = isPartnerRoleId(LocalStorageService.getRoleId());
    this.isPrimaryCompanyRole = isPrimaryCompanyRoleId(
      LocalStorageService.getRoleId()
    );
    this.userId = LocalStorageService.getUserId();
    this.isSubmittingFlag = false;

    this.state = {
      isLoading: false,
      statusMessage: null,
      visibleDialogName: null,
      isValidateSelect: false,
      selectedCompanyName: '',
      formValues: {
        id: this.ccusId,
        ccus_company_admin_id: null,
      },
      listUsers: [],
      defaultParams: {
        total: 0,
        offset: 0,
        limit: 0,
      },
      expirationCompany: {},
      isAgency: false,
      isAddition: false,
      agencyInfo: {},
      agentSelfFlag: false,
      userProfile: {},
      userCompanyName: '',
      deleteAgencyCompanyIds: [],
      showMinimumUserDialog: false,
      showNoUserDialog: false,
    };

    this.goPreviousPage = {
      callback: {
        clear: () => {
          _masterSlideLoader.show('PrimeCcusPreview', {
            state: { id: this.selectedCompanyId },
          });
          dialogLoader.close();
        },
        close: () => {
          dialogLoader.close();
        },
      },
    };
  }

  getExpiration = async () => {
    await CompanyService.expirations(this.selectedCompanyId).then(response => {
      if (!response.result) {
        return;
      }
      this.setState({
        expirationCompany: {
          ...this.state.expirationCompany,
          ...response.data.entities.company.expiration,
        },
      });
    });
  };

  componentDidMount() {
    this.getInfo();
    this.getExpiration();
  }

  componentWillUnmount() {
    requestCache.clear(); //割り当てでキャッシュしたレスポンスを解放
  }

  getInfo() {
    if (this.isRolePartner) {
      this.setCompanyName();
    } else {
      this.getListCompanyBranch();
    }

    if (this.props.page === CCUS_PAGE.CcusAdminUserEdit) {
      this.getListAdditions();
    }

    this.getBasicInfo();
    this.getAgencyInfo();
    this.getUserProfile();
  }

  setCompanyName = () => {
    this.setState(
      {
        isLoading: true,
      },
      async () => {
        const companyName = await getPartnerCompanyName(this.selectedCompanyId);
        this.setState({ selectedCompanyName: companyName, isLoading: false });
      }
    );
  };

  getBasicInfo = async () => {
    const response = await PrimeCCUSPreviewService.getBasicInfo(
      this.selectedCompanyId
    );
    if (response.result) {
      const entities = response.data.entities;
      this.setState({
        formValues: {
          ...this.state.formValues,
          ccus_company_admin_id:
            entities.ccus_company_admin.ccus_company_admin_id,
        },
      });
    }
  };

  getUserProfile = async () => {
    const response = await UserProfileService.show(this.userId);
    if (response.result) {
      const { user_profile, company } = response.data.entities;
      const isAgency = company[0].id !== parseInt(this.selectedCompanyId);
      this.setState(
        {
          userProfile: user_profile,
          userCompanyName: company[0].name,
          isAgency,
        },
        () => {
          this.getListUsers(this.ccusId);
        }
      );
    }
  };

  getListCompanyBranch = async () => {
    const response = await CompanyBranchService.companyBranchList(
      this.state.defaultParams
    );
    if (response.data.total > 0) {
      this.setState({
        defaultParams: {
          ...this.state.defaultParams,
          total: response.data.total,
          limit: response.data.total,
        },
      });
    }
  };

  getListUsers = async id => {
    const response = await PrimeCCUSPreviewService.getListUsersInfo(
      this.selectedCompanyId,
      { ccus_company_admin_id: id }
    );
    if (response.result) {
      this.isCreating = _.isEmpty(response.data.entities.ccus_company_admins);
      const listUsers = response.data.entities.ccus_company_admins;
      const selfInList = _.find(listUsers, user => {
        // 代行元の自分が含まれているかを確認
        return (
          user.user_id === this.userId &&
          _.has(user, 'agency_company_id') &&
          !_.isNull(user.agency_company_id)
        );
      });
      if (selfInList && this.state.isAgency) {
        this.setState({ agentSelfFlag: true });
      }
      const setNewListUsers = branch_id => {
        this.setState({
          listUsers: [
            ...listUsers,
            {
              [branch_id]: '',
              user_id: null,
              user_name: null,
            },
          ],
        });
      };
      if (this.isCreating) {
        if (this.isRolePartner) {
          setNewListUsers('partner_company_branch_id');
        } else {
          setNewListUsers('company_branch_id');
        }
      } else {
        this.setState({ listUsers });
      }
    }
  };

  getListAdditions = async () => {
    const response = await PrimeCCUSPreviewService.getListAdditionInfo(
      this.selectedCompanyId
    );
    if (response.result) {
      const listAdditionInfo = response.data.entities.ccus_company_admins;
      const item = _.find(listAdditionInfo, addditionInfo => {
        return addditionInfo.id === this.ccusId;
      });
      this.setState({
        formValues: {
          ...this.state.formValues,
          ccus_company_admin_id: item.ccus_company_admin_id,
        },
        isAddition: true,
      });
    }
  };

  getAgencyInfo = async () => {
    const response = await PrimeCCUSPreviewService.getAgencyInfo(
      this.selectedCompanyId
    );
    if (response.result) {
      this.setState({
        agencyInfo: response.data.entities.agency_info,
      });
    }
  };

  handleVisibleDialog = dialogName => {
    this.setState({ visibleDialogName: dialogName });
  };

  handleMinimumUserDialog = visibility => {
    this.setState({ showMinimumUserDialog: visibility });
  };

  handleNoUserDialog = visibility => {
    this.setState({ showNoUserDialog: visibility });
  };

  showStatusDialog = statusMessage => {
    this.handleVisibleDialog(true);
    this.setState({ statusMessage });
  };

  goBack = (showDialog = false) => {
    this.setState({ isShowCreateSuccess: false });
    if (showDialog) {
      dialogLoader.show(CloseEditView, this.goPreviousPage);
    } else {
      _masterSlideLoader.show('PrimeCcusPreview', {
        state: { id: this.selectedCompanyId },
      });
    }
  };

  setValueUser = (value, id) => {
    this.setState(prevState => ({
      listUsers: prevState.listUsers.map(user =>
        prevState.listUsers.indexOf(user) === id
          ? {
              ...user,
              user_id: value,
              clearFlag: false,
            }
          : { ...user, clearFlag: false }
      ),
    }));
  };

  setValueBranch = (value, id) => {
    const setNewListUsers = branch_id => {
      this.setState(prevState => ({
        listUsers: prevState.listUsers.map(user =>
          prevState.listUsers.indexOf(user) === id
            ? {
                ...user,
                [branch_id]: value !== HEAD_OFFICE_OPTION.id ? value : null,
                user_id: null,
                user_name: null,
                clearFlag: true,
              }
            : { ...user, clearFlag: false }
        ),
      }));
    };

    if (!_.isUndefined(value)) {
      if (this.isRolePartner) {
        setNewListUsers('partner_company_branch_id');
      } else {
        setNewListUsers('company_branch_id');
      }
    }
  };

  addUserInfo = () => {
    const setNewListUsers = branch_id => {
      this.setState({
        listUsers: [
          ...this.state.listUsers,
          {
            [branch_id]: '',
            user_id: null,
            user_name: null,
          },
        ],
        isValidateSelect: false,
      });
    };

    if (this.isRolePartner) {
      setNewListUsers('partner_company_branch_id');
    } else {
      setNewListUsers('company_branch_id');
    }
  };

  deleteUserInfo = id => {
    const newArray = [...this.state.listUsers];
    newArray.splice(id, 1);
    this.setState({
      listUsers: newArray,
    });
  };

  deleteAllAgencyUsers = companyId => {
    // 代行元連携ユーザーを一括で削除する
    const newArray = _.filter(
      this.state.listUsers,
      user => user.agency_company_id !== companyId
    );
    this.setState({
      deleteAgencyCompanyIds: [
        ...this.state.deleteAgencyCompanyIds,
        _.toString(companyId),
      ],
      listUsers: newArray,
    });
  };

  handleUpdateButton = () => {
    const selectedUsers = this.getUserIds();
    // ユーザーが一人以上選択されてる、もしくは0人でも「自分を連携ユーザーに設定」がチェックされてる場合、更新可能
    // 「その他の管理者情報」ではバリデーションがupdateUser()でチェックされるため、ダイアログ表示は不要
    if (
      selectedUsers.length > 0 ||
      this.state.agentSelfFlag ||
      this.props.page === CCUS_PAGE.CcusAdminUserEdit
    ) {
      this.updateUser();
    } else {
      // ユーザーが一人も選択されてない
      if (this.isPrimaryCompanyRole) {
        // 元請の場合、1名以上設定する必要があるダイアログを表示 - BLDE_V2-42611
        this.setState({ showMinimumUserDialog: true });
      } else if (this.isRolePartner) {
        // 協力会社・代行先の場合、連携ユーザーを登録せずに更新する確認ダイアログを表示 - BLDE_V2-42611
        this.setState({ showNoUserDialog: true });
      }
    }
  };

  /**
   * Buildeeユーザー一覧で選択したユーザーと「自分を連携ユーザーに設定」をまとめて配列として返す
   * @returns {array}
   */
  getUserIds = () => {
    return _.reduce(
      this.state.listUsers,
      (result, user) => {
        const { user_id } = user;
        if (
          user_id === this.userId &&
          _.has(user, 'agency_company_id') &&
          !_.isNull(user.agency_company_id) &&
          this.state.agentSelfFlag === false &&
          this.state.isAgency
        ) {
          // 一覧に"代行元の"自分が入ってる状態で「自分を連携ユーザーに設定」のチェックが外された場合、配列から外す
          // 代行先の連携ユーザー一覧のみ
          return result;
        }
        if (!_.isNull(user_id)) {
          if (
            _.has(user, 'agency_company_id') &&
            !_.isNull(user.agency_company_id) &&
            user_id !== this.userId
          ) {
            return result;
          }
          result.push(`${Number(user_id)}`);
        }

        return result;
      },
      []
    );
  };

  updateUser = async () => {
    if (this.isSubmittingFlag) {
      return;
    }
    this.isSubmittingFlag = true;
    // 更新ボタン
    this.setState({
      isValidateSelect: true,
    });
    if (this.props.page === CCUS_PAGE.CcusAdminUserEdit) {
      const data = _.filter(this.state.listUsers, user => {
        return user.user_id !== null;
      });

      if (_.isEmpty(data)) {
        this.isSubmittingFlag = false;
        return;
      }
    }
    let userIds = _.map(this.state.listUsers, user => {
      const { user_id } = user;

      // 代行先一覧>ユーザー一覧のみ
      // 一覧に代行元（agency_company_id!=null）の自分が入っている場合、配列から外す
      if (
        user_id === this.userId &&
        this.state.isAgency &&
        _.has(user, 'agency_company_id') &&
        !_.isNull(user.agency_company_id)
      ) {
        return;
      }
      if (!_.isNull(user_id)) {
        if (
          _.has(user, 'agency_company_id') &&
          !_.isNull(user.agency_company_id) &&
          user_id !== this.userId
        ) {
          return;
        }
        return `${Number(user_id)}`;
      }
    });
    const updateParams = {
      ccus_company_admin_id: String(this.ccusId),
      user_ids: userIds,
      agent_self_flag: _.cloneDeep(this.state.agentSelfFlag),
    };
    if (!_.isEmpty(this.state.deleteAgencyCompanyIds)) {
      updateParams.delete_agency_company_ids = _.cloneDeep(
        this.state.deleteAgencyCompanyIds
      );
    }
    const response = await PrimeCCUSPreviewService.updateUserInfo(
      this.selectedCompanyId,
      updateParams
    );
    this.isSubmittingFlag = false;
    if (response.result) {
      this.goBack();
    } else {
      this.showStatusDialog(response.data.message);
    }
  };

  setAgentSelfFlag = flag => {
    this.setState({
      agentSelfFlag: flag,
    });
  };

  render() {
    const {
      isLoading,
      selectedCompanyName,
      statusMessage,
      visibleDialogName,
      formValues,
      listUsers,
      isValidateSelect,
      agencyInfo,
      isAgency,
      isAddition,
      showMinimumUserDialog,
      showNoUserDialog,
    } = this.state;

    const title = `${selectedCompanyName}会社情報`;

    return (
      <div id='slide-view' className='contruction-slide-view show CcusUserEdit'>
        <Helmet>
          <title>
            {HEADER_CONSTANTS.title} - {title}
          </title>
        </Helmet>
        <div className='contruction-slide-view__view'>
          <MasterPageHeader
            loaded={!isLoading}
            loaderComponent={
              <div className='contruction-slide-view__title'>
                <ClipLoader size={20} color={'#EDB715'} />
              </div>
            }
            title={title}
            onClose={() => this.goBack(true)}
          />
          <div className='contruction-slide-view__body contruction-slide-view__body--height-fix'>
            <div className='contruction-detail-view'>
              <div className='contruction-detail-view__sidemenu'>
                {this.isPrimaryCompanyRole && (
                  <PrimaryCompanyNaviList
                    isSelectedCcusManagementInfo={true}
                    isEditable={true}
                    expirationCompany={this.state.expirationCompany}
                  />
                )}
                {this.isRolePartner && (
                  <PartnerNaviList
                    isCcusManagementInfo={true}
                    isEditable={true}
                    selectedPartnerCompanyId={this.selectedCompanyId}
                    expirationCompany={this.state.expirationCompany}
                  />
                )}
              </div>
              <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                <div className='contruction-detail-view__menu'>
                  <span className='construction-detail-view__button'>
                    <button
                      className='btn--sub'
                      onClick={() => this.goBack(true)}
                    >
                      {this.isCreating ? '登録をやめる' : '編集をやめる'}
                    </button>
                  </span>
                  <span className='construction-detail-view__button'>
                    <button
                      className='btn--effective'
                      onClick={this.handleUpdateButton}
                    >
                      {this.isCreating ? '登録' : '更新'}
                    </button>
                  </span>
                </div>
                <div className='contruction-detail-view__bar' />
                <div className='contruction-detail-view__main contruction-detail-view__main--fixed'>
                  <CcusUserDropdown
                    userValue={formValues.ccus_company_admin_id}
                    listUsers={listUsers}
                    setValueBranch={this.setValueBranch}
                    setValueUser={this.setValueUser}
                    addUserInfo={this.addUserInfo}
                    deleteUserInfo={this.deleteUserInfo}
                    isRolePartner={this.isRolePartner}
                    companyUserEdit={
                      this.props.page === CCUS_PAGE.CcusCompanyUserEdit
                    }
                    isValidateSelect={isValidateSelect}
                    agencyInfo={agencyInfo}
                    isAgency={isAgency}
                    isAddition={isAddition}
                    agentSelfFlag={this.state.agentSelfFlag}
                    setAgentSelfFlag={this.setAgentSelfFlag}
                    userName={`${this.state.userProfile.name_sei} ${this.state.userProfile.name_mei}`}
                    userId={this.state.userProfile.id}
                    userCompanyName={this.state.userCompanyName}
                    deleteAllAgencyUsers={this.deleteAllAgencyUsers}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <Information
          title='エラーが発生しました。'
          message={statusMessage}
          buttonText={messageUtility.getMessage('I-000-011')}
          visible={visibleDialogName}
          onClose={() => this.handleVisibleDialog(false)}
        />
        <Information
          title={messageUtility.getMessage('E-000-005')}
          message={messageUtility.getMessage('I-000-259')}
          buttonText={messageUtility.getMessage('I-000-017')}
          visible={showMinimumUserDialog}
          onClose={() => this.handleMinimumUserDialog(false)}
          multilineText
          rootClassName='inline-dialog-md'
        />
        <Confirmation
          rootClassName='inline-dialog-md'
          visible={showNoUserDialog}
          title={messageUtility.getMessage('E-000-005-01')}
          message={messageUtility.getMessage('I-000-260')}
          confirmButtonText={messageUtility.getMessage('I-000-167-13')}
          cancelButtonText={messageUtility.getMessage('I-000-178')}
          onConfirm={() => this.updateUser()}
          onCancel={() => this.handleNoUserDialog(false)}
          effectiveButtonClassName={'btn--effective'}
          multilineText
        />
      </div>
    );
  }
}

export class CcusAdminUserEdit extends React.Component {
  render() {
    return <CcusUserEdit {...this.props} page={CCUS_PAGE.CcusAdminUserEdit} />;
  }
}

export class CcusCompanyUserEdit extends React.Component {
  render() {
    return (
      <CcusUserEdit {...this.props} page={CCUS_PAGE.CcusCompanyUserEdit} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/CcusUserEdit.jsx